import ClientService from '../../../services/client-service';
import getNotificationListDataQuery from '../../../graphql/query/get-notification-list-data.graphql';
import deleteNotificationMutation from '../../../graphql/mutation/delete-notification.graphql';
import deleteAllNotificationsMutation from '../../../graphql/mutation/delete-all-notifications.graphql';
import readNotificationsMutation from '../../../graphql/mutation/read-notifications.graphql';
import notificationAddedSubscription from '../../../graphql/subscription/notification-added.graphql';

export default class NotificationsApi {
  public static getNotificationListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getNotificationListDataQuery, payload);
  }

  public static deleteNotification(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deleteNotificationMutation, payload);
  }

  public static deleteAllNotifications(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deleteAllNotificationsMutation, payload);
  }

  public static readNotifications(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(readNotificationsMutation, payload);
  }

  public static notificationAdded(payload: ActionPayload, callback: Function): Promise<ApolloClientSubscription> {
    return ClientService.sendGraphqlSubscriptionRequest(notificationAddedSubscription, payload, callback);
  }
}
